module.exports = __webpack_public_path__ + "img/t1.8f76db9d.jpg";